import React from 'react';

import { Link } from 'react-router-dom';
import { Layout } from 'components/organisms/layout';
import { ContentsTitle } from 'components/molecules';
/** styles **/
import { ReactComponent as BlackCircleArrow } from 'assets/images/black-circle-arrow.svg';
import { WhatIsPman, PossibleItems, OurFutures, Concept, Member } from 'components/organisms';
import s from '../styles/pages/about.module.scss';

export const About: React.FC = () => {
  return (
    <Layout>
      <div className={s.aboutPageWrapper}>
        <ContentsTitle className={s.contentsTitle} title="WHAT'S P-man" subTitle="ピーマンとは" />
        <div className={s.aboutContent}>

          <WhatIsPman />
          <div id="items">
            <PossibleItems />
          </div>
          <div id="features">
            <OurFutures />
          </div>
          <div id="concept">
            <Concept />
          </div>
          <div id="member">
            <Member />
          </div>
        </div>

        <Link className={s.topLink} to="/">
          <BlackCircleArrow className={s.navButton} />トップページへ戻る
        </Link>
      </div>
    </Layout>
  );
};